import React from 'react';
import '../../bootstrap.css';
import FoodLoggingForm2 from './FoodLoggingForm2';
import * as Database from '../../helpers/Database';
import { getLocalTimeString } from '../../helpers/Util.js';
import RecipeBuilder from './RecipeBuilder';
let _ = require('lodash');

export default class LoggedFoodsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showFoodLoggingForm: false,
      togglePromptDeletion: false,
      showMigrationForm: false,
      newTargetDate: this.props.food.targetDate, // For moving food from one date to another.
      errorMessage: '',
      recipeName: null, // We'll default to using this.props.dataEntryContent.name until this is explicitly set in _updateRecipe.
      totalServings: this.props.dataEntryContent ? this.props.dataEntryContent.totalServings : null,
      disableUpdateRecipeBtn: false,
      showRecipeBuilder: false,
    };
  }

  _toggleShowFoodForm = () => {
    this.setState({
      showFoodLoggingForm: !this.state.showFoodLoggingForm
    });
  }

  _toggleShowRecipeBuilder = () => {
    this.setState({
      showRecipeBuilder: !this.state.showRecipeBuilder
    });
  }

  _togglePromptDeletion = () => {
    this.setState({
      promptDeletion: !this.state.promptDeletion
    });
  }

  _toggleMigrationForm = () => {
    this.setState({
      showMigrationForm: !this.state.showMigrationForm
    });
  }

  _newTargetDateChange = (e) => {
    this.setState({
      newTargetDate: e.target.value
    });
  }

  _moveToNewTargetDate = async () => {
    let movedFood = _.clone(this.props.food);
    movedFood.targetDate = this.state.newTargetDate;
    await Database.logAllFoodsAndReportsAsync(
      this.props.userId,
      [{ 'foodEntry': movedFood, 'docId': this.props.docId }],
      Database.SUBMIT_FOOD_INTENTION.Move,
      false
    );
    await Database.deleteFood(this.props.userId, this.props.food.targetDate, this.props.docId);
  }

  _copyToNewTargetDate = async () => {
    let docId = this.props.docId;
    if (this.props.food.targetDate === this.state.newTargetDate) {
      docId = `${docId}_${Math.floor(Math.random() * 10000)}`;
    }

    let movedFood = _.clone(this.props.food);
    movedFood.targetDate = this.state.newTargetDate;
    await Database.logAllFoodsAndReportsAsync(
      this.props.userId,
      [{ 'foodEntry': movedFood, 'docId': docId }],
      Database.SUBMIT_FOOD_INTENTION.Copy,
      false
    );
    this._toggleMigrationForm();
  }

  _deleteFood = async () => {
    // Why not use this.props.food.targetDate? It's possible that this food item is an empty doc
    // as a result of some bad state and we want to be able to delete it if food.targetDate doesn't exist.
    await this.props.onDelete(this.props.userId, this.props.targetDate, this.props.docId);
  }

  _correctFood = async (foodFormEntry) => {
    let result = await this.props.onCorrect(this.props.userId, this.props.food, foodFormEntry, this.props.docId);
    if (result && result.error) {
      this.setState({
        errorMessage: result.error
      });
    } else {
      this._toggleShowFoodForm();
    }
  }

  _updateRecipe = async (name, ingredients, totalServings) => {
    this.setState({
      disableUpdateRecipeBtn: true,
    });

    await Database.rebuildRecipeCart(this.props.userId, this.props.docId, ingredients, totalServings);
    this.setState({
      recipeName: name,
      showRecipeBuilder: true,
      showFoodLoggingForm: false,
      totalServings: totalServings,
      disableUpdateRecipeBtn: false,
    });
  }

  render() {
    var promptDeletionPopup =
      <div
        style={{
          width: '400px',
          height: '300px',
          borderWidth: '2px',
          borderColor: 'black',
          border: 'solid',
          position: 'absolute',
          backgroundColor: 'white',
          left: '50%',
          zIndex: '100',
          padding: '10px'
        }}
      >
        <div>ARE YOU SURE? Once you delete this food, you can NOT recover it.</div>
        <button
          style={{ margin: '10px' }}
          onClick={this._deleteFood}
        >
          Yes, Delete
        </button>
        <button style={{ margin: '10px' }} onClick={this._togglePromptDeletion}>
          No, Cancel
        </button>
      </div>;

    const hasImages = this.props.images && this.props.images[0];
    let image =
      hasImages ?
        <img alt="(picture)" style={{ maxWidth: "100%" }} src={this.props.images[0]}></img> :
        <span />;

    let recipeBuilder = <RecipeBuilder
      recipeName={this.state.recipeName ? this.state.recipeName : this.props.food.name}
      userId={this.props.userId}
      targetDate={this.props.targetDate}
      userStatus={this.props.userStatus}
      adminId={this.props.adminId}
      onClose={this._toggleShowRecipeBuilder}
      emptyCartAfterSubmit={true}
      onSubmitEverything={() => {
        this._toggleShowRecipeBuilder();
        this._toggleShowFoodForm();
      }}
      logId={this.props.docId}
      totalServings={this.state.totalServings}
    />;

    var foodLoggingForm =
      <div className='row' style={{ marginBottom: '10px' }}>
        <div className='col-2'>{image} {this.props.revisionHistory}</div>
        <div className='col-1'>{this.props.food.name}</div>
        <div className='col-1'>{this.props.food.consolidatedServingName}</div>
        <div className='col'>
          <FoodLoggingForm2
            userId={this.props.userId}
            userStatus={this.props.userStatus}
            adminId={this.props.adminId}
            targetDate={this.props.targetDate}
            onSubmit={this._correctFood}
            onClose={this._toggleShowFoodForm}
            loggedTimestamps={this.props.food.loggedTimestamps}
            hasImages={hasImages}
            updateRecipe={this.state.disableUpdateRecipeBtn ? null : this._updateRecipe}
            foodTagRequired={!this.props.isIngredient}
          />
        </div>
        <hr />
      </div>;

    let lastUpdated = this.props.ignoreTimestamps ? <span /> :
      <div>
        <small>
          [User logged at: {getLocalTimeString(this.props.firstLoggedTimestamp, this.props.userStatus.timezoneOffset)}]
        </small>
      </div>;
    var foodMigrationForm =
      <div className='row' style={{ marginBottom: '10px' }}>
        <div className='col-2'>
          {image}
          {this.props.revisionHistory}
        </div>
        <div className='col-1'>{this.props.food.name}</div>
        <div className='col-1'>{this.props.food.consolidatedServingName}</div>
        <div className='col-5' style={{ marginTop: '10px', textAlign: 'right' }}>
          <button style={{ marginBottom: '10px' }} onClick={this._toggleMigrationForm}>
            Dismiss
          </button>
          <div>
            <input type="date" value={this.state.newTargetDate} onChange={this._newTargetDateChange} />
          </div>
          <div style={{ marginTop: '10px' }}>
            <button style={{ marginRight: '10px' }} onClick={this._moveToNewTargetDate}>
              MOVE
            </button>
            <button onClick={this._copyToNewTargetDate}>
              COPY
            </button>
          </div>
        </div>
        <hr />
      </div>;

    return (
      <div style={{ padding: '10px', marginBottom: '10px', backgroundColor: this.state.promptDeletion ? 'red' : 'white' }}>
        {
          this.state.promptDeletion ? promptDeletionPopup : <span />
        }
        <div style={{ color: "red" }}>{this.state.errorMessage}</div>
        {lastUpdated}
        {
          this.state.showRecipeBuilder ?
            recipeBuilder : <span />
        }
        {
          this.state.showFoodLoggingForm ?
            foodLoggingForm :
            this.state.showMigrationForm ?
              foodMigrationForm :
              <div className='row' style={{ marginBottom: '10px' }}>
                <div className='col-2'>
                  {image}
                  {this.props.revisionHistory}
                </div>
                <div className='col-1'>{this.props.food.name}</div>
                <div className='col-1'>{this.props.food.consolidatedServingName}</div>
                <div className='col-1'>{this.props.food.calories}</div>
                <div className='col-1'>{this.props.food.carbs}</div>
                <div className='col-1'>{this.props.food.protein}</div>
                <div className='col-1'>{this.props.food.fat}</div>
                <div className='col-1'>
                  {
                    this.props.food.foodGroups ?
                      this.props.food.foodGroups.map(foodGroup => `• ${foodGroup}\n`) :
                      <span />
                  }
                </div>
                {
                  this.state.promptDeletion ?
                    <span /> :
                    <div className='col-1'>
                      <div>
                        <input type="submit" onClick={this._toggleShowFoodForm} value="Edit" />
                      </div>
                      <div
                        style={
                          this.state.showMigrationForm ?
                            { marginTop: '10px', border: 'solid', padding: '10px', backgroundColor: 'yellow' } :
                            { marginTop: '10px' }
                        }
                      >
                        {
                          this.props.enableDateMigration ?
                            <button onClick={this._toggleMigrationForm}>
                              Move/Copy
                            </button> :
                            <span />
                        }
                      </div>
                      <div style={{ marginTop: '10px' }}>
                        <input type="submit" onClick={this._togglePromptDeletion} value="Delete" />
                      </div>
                    </div>
                }
                <hr />
              </div>
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/main/foodLogging/LoggedFoodsTableRow.js